<div *ngIf="display">
    <div class="container-fluid common-pages-banner">
        <div class="container pd-0">
            <div class="tg-theme-heading">
                <h1 class="h1tags">{{ headingTag}}</h1>
            </div>
        </div>
    </div>
    <div class="container-fluid main-padding ">
        <!-- <div class=" p-0 mp015"> -->
        <div class="row breadcrumbSection bg-light px-5">
            <div class="col-md-10 pr-0 mp0">
                <div class="breaeea">
                    <ul class="breadcrumb" *ngIf="breadCrumbType=='buy'">
                        <li><a routerLink="/">Home</a></li>
                        <li>Buy</li>
                    </ul>

                    <ul class="breadcrumb" *ngIf="breadCrumbType=='rent'">
                        <li><a routerLink="/">Home</a></li>
                        <li>Rent</li>
                    </ul>

                    <ul class="breadcrumb" *ngIf="breadCrumbType=='pg'">
                        <li><a routerLink="/">Home</a></li>
                        <li>PG</li>
                    </ul>

                    <ul class="breadcrumb" *ngIf="breadCrumbType=='buy_residential'">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/buy/residential-property-for-sale-in-{{getSelectedCity.slug}}">Buy</a></li>
                        <li>Residential</li>
                    </ul>

                    <ul class="breadcrumb" *ngIf="breadCrumbType=='buy_commercial'">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/buy/commercial-property-for-sale-in-{{getSelectedCity.slug}}">Buy</a></li>
                        <li>Commercial</li>
                    </ul>
                    <ul class="breadcrumb" *ngIf="breadCrumbType=='buy_agriculture'">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/buy/agriculture-for-sale-in-{{getSelectedCity.slug}}">Buy</a></li>
                        <li>Agriculture</li>
                    </ul>
                    <ul class="breadcrumb" *ngIf="breadCrumbType=='buy_industrial'">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/buy/industrial-property-for-sale-in-{{getSelectedCity.slug}}">Buy</a></li>
                        <li>Industrial</li>
                    </ul>
                    <ul class="breadcrumb" *ngIf="breadCrumbType=='rent_industrial'">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/rent/industrial-property-for-rent-in-{{getSelectedCity.slug}}">Rent</a></li>
                        <li>Industrial</li>
                    </ul>
                    <ul class="breadcrumb" *ngIf="breadCrumbType=='rent_commercial'">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/rent/commercial-property-for-rent-in-{{getSelectedCity.slug}}">Rent</a></li>
                        <li>Commercial</li>
                    </ul>

                    <ul class="breadcrumb" *ngIf="breadCrumbType=='rent_agriculture'">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/rent/agriculture-for-rent-in-{{getSelectedCity.slug}}">Rent</a></li>
                        <li>Agriculture</li>
                    </ul>

                    <ul class="breadcrumb" *ngIf="breadCrumbType=='rent_residential'">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/rent/residential-property-for-rent-in-{{getSelectedCity.slug}}">Rent</a></li>
                        <li>Residential</li>
                    </ul>
                </div>
            </div>
        </div>

        <app-matloader *ngIf="listingLoader"></app-matloader>
        <!-- new sort and filter button -->
        <div class="mobile-filter">
            <div class="row sort-filter">
                <div class="col-md-6 w-50">
                    <button class="btn default btn primary flat results-btn showSortBy" (click)="openMobileSort()" data-toggle="modal" data-target="#sortmodel" id=""><svg width="24" height="24"
                                viewBox="0 0 24 24" class="result-icon">
                                <g fill="none" fill-rule="evenodd">
                                    <path d="M0 0h24v24H0z" opacity="0.05"></path>
                                    <path fill="#282C3F"
                                        d="M7.445 7.48V5.672L5.665 7.48h1.78zm1.09-4.42c.304.12.465.39.465.706v16.437a.784.784 0 01-.783.797.762.762 0 01-.772-.781V8.982H4.003a.832.832 0 01-.765-.204.759.759 0 01.002-1.105L7.652 3.23a.832.832 0 01.882-.17zm8.02 15.269l1.78-1.81h-1.78v1.81zm4.207-3.107a.76.76 0 01-.002 1.106l-4.412 4.442a.832.832 0 01-.882.17c-.305-.12-.466-.39-.466-.706V3.797c0-.432.332-.797.783-.797.45 0 .772.35.772.781v11.237h3.442a.833.833 0 01.765.204z">
                                    </path>
                                </g>
                            </svg>SORT</button>
                </div>
                <div class="col-md-6 w-50">
                    <button class="btn default    btn primary flat results-btn" (click)="openFilterForMobile()" id="sort-btn"><svg width="24" height="24" viewBox="0 0 24 24" class="result-icon">
                                <g fill="none" fill-rule="evenodd">
                                    <path d="M0 0h24v24H0z" opacity="0.05"></path>
                                    <path fill="#282C3F"
                                        d="M3.749 7.508a.75.75 0 010-1.5h3.138a2.247 2.247 0 014.243 0h9.121a.75.75 0 010 1.5h-9.126a2.248 2.248 0 01-4.232 0H3.749zm13.373 9h3.129a.75.75 0 010 1.5h-3.135a2.247 2.247 0 01-4.231 0H3.749a.75.75 0 010-1.5h9.13a2.248 2.248 0 014.243 0z">
                                    </path>
                                </g>
                            </svg>FILTER</button>
                </div>
            </div>
            <!-- new sort modal offcanvas -->
            <div class="w-100 vh-100 popup-content">
                <div class="bottom sort-by">
                    <ul class="list list-sort">
                        <li class="sortby sortby-des">
                            <span> SORT BY</span>
                            <div (click)="hideSorting()" class="hideSortBy"> <img style="width: 22px;" src="assets/images/cross-circle.svg" alt="" class="img-fluid"></div>
                        </li>
                        <li class="">
                            <div class="ripple-container ">
                                <button class=" default" style="padding-left: 25px;">
                                        <span class="sortByValues pl-2">
                                            <input hidden type="radio" id="relevence" value="1"
                                                [formControl]="mobile_sort_by">
                                            <label for="relevence"> <i class="fa fa-binoculars"></i>
                                                <span>Relevence</span></label></span>
                                    </button>
                                <div class="ripple"></div>
                            </div>
                        </li>
                        <li class="">
                            <div class="ripple-container ">
                                <button class=" default">
                                        <span class="sortByValues">
                                            <input hidden type="radio" id="High" value="2" [formControl]="mobile_sort_by">
                                            <label for="High"><svg width="24" height="24" viewBox="0 0 24 24"
                                                    class="SortModalIcon">
                                                    <g fill="none" fill-rule="evenodd">
                                                        <path d="M0 0h24v24H0z" opacity="0.05"></path>
                                                        <path
                                                            d="M4 6.215h4.962v2.43H4.505L4.13 9.858h4.764a3.05 3.05 0 01-.827 1.539 2.99 2.99 0 01-2.022.895l-1.361-.003a.304.304 0 00-.214.519l6.717 6.779 1.697-.004-6.107-6.16a4.193 4.193 0 002.14-1.167 4.256 4.256 0 001.198-2.398h2.474l.376-1.215h-2.799v-2.43h3.496V5H4v1.215zm12.389 10.028h1.337l-1.337 1.354v-1.354zm-.818 3.309c.23.09.488.04.663-.127l3.312-3.326a.567.567 0 000-.828.627.627 0 00-.574-.152H16.39v-5.043a.571.571 0 00-.58-.585.587.587 0 00-.587.597v8.935c0 .237.12.439.35.529z"
                                                            fill="#282C3F"></path>
                                                    </g>
                                                </svg>
                                                <span> Price: Low to High</span></label></span>
                                    </button>
                                <div class="ripple"></div>
                            </div>
                        </li>
                        <li class="">
                            <div class="ripple-container ">
                                <button class=" default">
                                        <span class="sortByValues">
                                            <input hidden type="radio" id="low" value="3" [formControl]="mobile_sort_by">
                                            <label for="low"> <svg width="24" height="24" viewBox="0 0 24 24"
                                                    class="SortModalIcon">
                                                    <g fill="none" fill-rule="evenodd">
                                                        <path d="M0 0h24v24H0z" opacity="0.05"></path>
                                                        <path
                                                            d="M4 6.136h4.637v2.272H4.472l-.351 1.135h4.45a2.855 2.855 0 01-.772 1.44c-.51.514-1.177.81-1.888.836H5.91l-1.272-.002c-.25-.001-.377.305-.2.484l6.276 6.338 1.586-.002-5.706-5.76a3.92 3.92 0 002-1.092 3.984 3.984 0 001.119-2.242h2.311l.352-1.135H9.76V6.136h3.267V5H4v1.136zm12.626.733l1.249 1.265h-1.25V6.869zm-1.09-1.333v8.35c0 .3.232.557.548.557a.534.534 0 00.542-.547V9.184h2.414a.586.586 0 00.537-.143.53.53 0 00-.001-.773L16.48 5.161a.585.585 0 00-.62-.12.508.508 0 00-.326.495z"
                                                            fill="#282C3F"></path>
                                                    </g>
                                                </svg>
                                                <span>Price: High to Low </span></label> </span>
                                    </button>
                                <div class="ripple"></div>
                            </div>
                        </li>

                        <li class="">
                            <div class="ripple-container ">
                                <button style="padding-left: 29px;" class=" default">
                                        <span class="sortByValues pl-2"> <input hidden type="radio" id="New" value="4"
                                                [formControl]="mobile_sort_by">
                                            <label for="New"> <i class="fa fa-delicious"></i> <span>Old to
                                                    New</span></label> </span>
                                    </button>
                                <div class="ripple"></div>
                            </div>
                        </li>
                        <li class="">
                            <div class="ripple-container "><button class=" default" style="padding-left: 29px;">
                                        <span class="sortByValues pl-2">
                                            <input hidden type="radio" id="Old" value="5" [formControl]="mobile_sort_by">
                                            <label for="Old"> <i class="fa fa-glass"></i> <span>New to Old </span>
                                            </label></span></button>
                                <div class="ripple"></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <section class=" filterheader">
                <div class="container p-0">
                    <header class="d-flex justify-content-between  text-center mb-2 text-dark header1">
                        <p class="mb-1">FILTERS </p>
                        <p class="mb-1" style="color: #db0c0c;">CLEAR ALL</p>
                    </header>
                    <div class="row">
                        <div class="col-md-6 w-50 p-0" style="background: #f5f5f6; height: 100vh;">
                            <!-- Tabs nav -->
                            <div class="nav flex-column nav-pills nav-pills-custom" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                <a class="nav-link mb-3 p-3  active" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true">
                                    <span class="font-weight-bold small text-uppercase">Property Type</span></a>

                                <a class="nav-link mb-3 p-3 " id="v-pills-profile-tab" data-toggle="pill" href="#v-pills-profile" role="tab" aria-controls="v-pills-profile" aria-selected="false" *ngIf="searchForm.value.property_type === '1' || searchForm.value.property_type === '2'">

                                    <span class="font-weight-bold small text-uppercase">Type Of Property</span></a>

                                <a class="nav-link mb-3 p-3 " id="v-pills-messages-tab" data-toggle="pill" href="#v-pills-messages" role="tab" aria-controls="v-pills-messages" aria-selected="false">

                                    <span class="font-weight-bold small text-uppercase">Location</span></a>

                                <a class="nav-link mb-3 p-3 " id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings5" role="tab" aria-controls="v-pills-settings" aria-selected="false">

                                    <span class="font-weight-bold small text-uppercase">Sale Type</span></a>

                                <a class="nav-link mb-3 p-3 " id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings6" role="tab" aria-controls="v-pills-settings" aria-selected="false">

                                    <span class="font-weight-bold small text-uppercase">Possession Type</span></a>

                                <a class="nav-link mb-3 p-3 " id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings7" role="tab" aria-controls="v-pills-settings" aria-selected="false">

                                    <span class="font-weight-bold small text-uppercase">Listed By</span></a>

                                <a class="nav-link mb-3 p-3 " id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings" role="tab" aria-controls="v-pills-settings" aria-selected="false">

                                    <span class="font-weight-bold small text-uppercase">Budget</span></a>
                                <a class="nav-link mb-3 p-3 " id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings1" role="tab" aria-controls="v-pills-settings" aria-selected="false" *ngIf="searchForm.value.property_type === '3'">

                                    
                                    <span class="font-weight-bold small text-uppercase">Available category
                                        </span></a>
                                <a class="nav-link mb-3 p-3 " id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings2" role="tab" aria-controls="v-pills-settings" aria-selected="false" *ngIf="searchForm.value.property_type === '3'">

                                    <span class="font-weight-bold small text-uppercase">Available for
                                        </span></a>
                                <ng-container *ngIf="searchForm.value.property_type=='1' ||  searchForm.value.property_type=='2'">
                                    <a class="nav-link mb-3 p-3 " id="v-pills-settings-tab" data-toggle="pill" href="#v-pills-settings3" role="tab" aria-controls="v-pills-settings" aria-selected="false" *ngIf="setProopertyTypeArray.includes('1') &&  !setProopertyTypeArray.includes('2') &&  !setProopertyTypeArray.includes('4')">

                                        <span class="font-weight-bold small text-uppercase">No of BHk
                                            </span></a>
                                </ng-container>
                            </div>
                        </div>


                        <div class="col-md-6 w-50 p-0">
                            <form [formGroup]="searchForm" (ngSubmit)="applyFilter()" method="post" class="minm-for" accept-charset="utf-8" id="filter">
                                <!-- <div class="client-search"><svg width="14" height="14" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path fill="#3E4152" d="M3.438 9.754a6.415 6.415 0 016.408-6.409 6.415 6.415 0 016.409 6.409 6.416 6.416 0 01-6.409 6.408 6.416 6.416 0 01-6.408-6.408M21.816 20.87l-5.974-6.02a7.839 7.839 0 001.88-5.097c0-4.343-3.534-7.875-7.876-7.875-4.342 0-7.875 3.532-7.875 7.875 0 4.342 3.533 7.875 7.875 7.875a7.837 7.837 0 004.946-1.753l5.983 6.029a.73.73 0 001.037.004.733.733 0 00.004-1.038"></path><path d="M0 0h24v24H0z" opacity="0.05"></path></g></svg><input class="searchInput" placeholder="Search by Categories" type="text" value=""></div> -->
                                <div class="tab-content filter-tab-content" id="v-pills-tabContent">
                                    <div class="tab-pane fade  rounded bg-white show active p-1 ft-h4" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                                        <input type="radio" id="fruit1" value="2" class="checkinput" formControlName="property_type" hidden>
                                        <label for="fruit1">Buy</label>
                                        <input type="radio" id="fruit2" value="1" class="checkinput" formControlName="property_type" hidden>
                                        <label for="fruit2">Rent </label>
                                        <input type="radio" id="fruit3" value="3" class="checkinput" formControlName="property_type" hidden>
                                        <label for="fruit3">PG</label>
                                    </div>
                                    <div class="tab-pane fade  rounded bg-white p-1 ft-h4" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                                        <div class="res-box">
                                            <div class="card" (click)="div1Function1()">
                                                <p class="cust_p">Residential</p>
                                                <span class="checkmark"></span>
                                            </div>
                                            <div class="res-child" *ngIf="div1Function">

                                                <input name="BHK" [checked]="getBhkValue.includes('1')"  value="1" (change)="setNoOfBhkValue($event)" type="checkbox" id="BHK1" class="checkinput noof_bhk bhk_checked">
                                                <label for="BHK1">1 BHK</label>

                                                <input name="BHK" [checked]="getBhkValue.includes('2')" value="2" (change)="setNoOfBhkValue($event)" type="checkbox" id="BHK2" class="checkinput noof_bhk bhk_checked">
                                                <label for="BHK2">2 BHK</label>

                                                <input name="BHK" [checked]="getBhkValue.includes('3')" value="3" (change)="setNoOfBhkValue($event)" type="checkbox" id="BHK3" class="checkinput noof_bhk bhk_checked">
                                                <label for="BHK3">3 BHK</label>

                                                <input name="BHK" [checked]="getBhkValue.includes('4')"  value="4" (change)="setNoOfBhkValue($event)" type="checkbox" id="BHK4" class="checkinput noof_bhk bhk_checked">
                                                <label for="BHK4">3+ BHK</label>
                                                
                                                <input name="BHK" [checked]="setProopertyTypeValuesArray.includes('8')" (change)="setPropertyTypeValues($event)" value="8" type="checkbox" id="BHK5" class="checkinput noof_bhk bhk_checked property_typesvalues">
                                                <label for="BHK5">Villa</label>

                                                <input type="checkbox" id="fruit5" [checked]="setProopertyTypeArray.includes('1')" value="1" (click)="setPropertyTypeValue()" class="checkinput looking_type">
                                                <label for="fruit5">Appartment/Flat <br>/Bulder/Floor</label>

                                                <input type="checkbox" id="fruit6" [checked]="setProopertyTypeArray.includes('2')" value="2" (click)="setPropertyTypeValue()" class="checkinput looking_type">
                                                <label for="fruit6">Independent House</label>
                                            
                                                <ng-container *ngIf="searchForm.value.property_type == '2'">
                                                    <input type="checkbox" id="fruit7" [checked]="setProopertyTypeArray.includes('4')" value="4" (click)="setPropertyTypeValue()" class="checkinput looking_type">
                                                    <label for="fruit7">Residential Plot/Land</label>
                                                </ng-container>
                                            </div>
                                        </div>
                                        <div class="res-box">
                                            <div class="card" (click)="div2Function2()">
                                                <p class="cust_p">Commercial</p>
                                                <span class="checkmark"></span>
                                            </div>
                                            <div class="res-child" *ngIf="div2Function">
                                                

                                                <input [checked]="setProopertyTypeValuesArray.includes('commercialplot')" type="checkbox" id="fruit12" (change)="setPropertyTypeValues($event)" class="checkinput looking_type" value="commercialplot">
                                                <label for="fruit12">Commercial Plots</label>

                                                <input [checked]="setProopertyTypeValuesArray.includes('9')" type="checkbox" id="fruit13" (change)="setPropertyTypeValues($event)" class="checkinput looking_type" value="9">
                                                <label for="fruit13">Commercial Shops</label>
                                                
                                                <input type="checkbox" id="fruit9" class="checkinput looking_type" [checked]="setProopertyTypeArray.includes('5')" value="5" (click)="setPropertyTypeValue()">
                                                <label for="fruit9">Commercial Showroom</label>
                                                
                                                <input type="checkbox" id="fruit10" class="checkinput looking_type" [checked]="setProopertyTypeArray.includes('6')" value="6" (click)="setPropertyTypeValue()">
                                                <label for="fruit10">Commercial Office</label>

                                                <input type="checkbox" id="fruit11" class="checkinput looking_type" [checked]="setProopertyTypeArray.includes('commercialland')" value="commercialland" (click)="setPropertyTypeValue()">
                                                <label for="fruit11">Commercial Land</label>

                                            </div>
                                        </div>
                                        <div class="res-box">
                                            <div class="card" (click)="div3Function3()">
                                                <p class="cust_p">Agriculture</p>
                                                <span class="checkmark"></span>
                                            </div>
                                            <div class="res-child" *ngIf="div3Function">
                                                <input type="checkbox" id="fruit13" class="checkinput looking_type" [checked]="setProopertyTypeArray.includes('8')" value="8" (click)="setPropertyTypeValue()">
                                                <label for="fruit13">Agriculture Land</label>
                                                <input type="checkbox" id="fruit14" class="checkinput looking_type" [checked]="setProopertyTypeArray.includes('9')" value="9" (click)="setPropertyTypeValue()">
                                                <label for="fruit14">Farmhouse</label>
                                            </div>
                                        </div>
                                        <div class="res-box">
                                            <div class="card" (click)="div4Function4()">
                                                <p class="cust_p">Industrial</p>
                                                <span class="checkmark"></span>
                                            </div>
                                            <div class="res-child" *ngIf="div4Function">
                                                <input type="checkbox" id="fruit16" class="checkinput looking_type" [checked]="setProopertyTypeArray.includes('10')" value="10" (click)="setPropertyTypeValue()">
                                                <label for="fruit16">Industry Plot</label>
                                                <input type="checkbox" id="fruit17" class="checkinput looking_type" [checked]="setProopertyTypeArray.includes('13')" value="13" (click)="setPropertyTypeValue()">
                                                <label for="fruit17">Factory</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade  rounded bg-white p-1 ft-h4" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 p-0 ng-autocomplete nes filter-input  form-control border-right-1 border-light  mb-3 pac-target-input" *ngIf="searchCategory=='buy' || searchCategory=='rent' || searchCategory=='pg' || searchCategory=='findAnAgent'">
                                            <ng-autocomplete (selected)="getSelectCity($event)" [initialValue]="initialValue" [data]="cityList" [searchKeyword]="keyword" placeHolder="Enter City" [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate" class="position-relative">
    
    
                                            </ng-autocomplete>
                                            <span class="focus-input100"></span>
                                       
                                            <ng-template #itemTemplate let-item>
                                                <div class="item">
                                                    <span [innerHTML]="item.name"></span>
                                                </div>
                                            </ng-template>
                                            <ng-template #notFoundTemplate let-notFound>
                                                <div [innerHTML]="notFound">City Not found.</div>
                                            </ng-template>
                                        </div>
                                        <input class="searchInput" placeholder="Type Location" ngx-google-places-autocomplete value="{{ searchForm.value.location }}" (keyup)="handleAddressChange($event,'mannual')" (onAddressChange)="handleAddressChange($event,'address')" [options]="options">
                                    </div>
                                    
                                    <div class="tab-pane fade  rounded bg-white p-1 ft-h4" id="v-pills-settings" role="tabpanel" aria-labelledby="v-pills-settings-tab">
                                        <select name="" class='budget-sel' formControlName="min_budget">
                                                <option value="">Min</option>
                                                <option *ngFor="let minPrice of budgetMin" value="{{ minPrice }}">
                                                    {{ getBudgetWords(minPrice) }}</option>
                                            </select>
                                        <select name="" class="budget-sel" formControlName="max_budget">
                                                <option value="">Max</option>
                                                <option *ngFor="let maxPrice of getBudgetMaxValue()" value="{{ maxPrice }}">
                                                    {{ getBudgetWords(maxPrice) }}</option>
                                            </select>
                                    </div>
                                   
                                    <div class="tab-pane fade  rounded bg-white p-1 ft-h4" id="v-pills-settings1" role="tabpanel" aria-labelledby="v-pills-settings-tab">
                                        <input type="checkbox" id="fruit18" name="fruit-18" value="1" (click)="setValueOfPgAvl()" [checked]="getPgAvlValue.includes('1')" class="checkinput pgAvailable">
                                        <label for="fruit18">For Professionals</label>
                                        <input type="checkbox" id="fruit19" name="fruit-19" value="2" (click)="setValueOfPgAvl()" [checked]="getPgAvlValue.includes('2')" class="checkinput pgAvailable">
                                        <label for="fruit19">For Students </label>
                                        <input type="checkbox" id="fruit20" name="fruit-20" value="3" (click)="setValueOfPgAvl()" [checked]="getPgAvlValue.includes('3')" class="checkinput pgAvailable">
                                        <label for="fruit20">For Both</label>
                                    </div>
                                    <div class="tab-pane fade  rounded bg-white p-1 ft-h4" id="v-pills-settings5" role="tabpanel" aria-labelledby="v-pills-settings-tab">
                                        <input formControlName="sale_type" type="checkbox" id="Sale_type1" name="sale_type1" value="2" class="checkinput pgAvailable">
                                        <label for="Sale_type1">New Property</label>
                                        <input formControlName="sale_type" type="checkbox" id="Sale_type2" name="sale_type1" value="1" class="checkinput pgAvailable">
                                        <label for="Sale_type2">Sale</label>
                                    </div>
                                    <div class="tab-pane fade  rounded bg-white p-1 ft-h4" id="v-pills-settings6" role="tabpanel" aria-labelledby="v-pills-settings-tab">
                                        <input name="possession" formControlName="possession_type" type="checkbox" id="possession_type1"  value="1" class="checkinput pgAvailable">
                                        <label for="possession_type1">Ready To Move</label>
                                        <input name="possession" formControlName="possession_type" type="checkbox" id="possession_type2"  value="2" class="checkinput pgAvailable">
                                        <label for="possession_type2">Under Construction</label>
                                    </div>
                                    <div class="tab-pane fade  rounded bg-white p-1 ft-h4" id="v-pills-settings7" role="tabpanel" aria-labelledby="v-pills-settings-tab">
                                        <input name="listed" formControlName="listed_by" type="checkbox" id="listed_1" value="2" class="checkinput pgAvailable">
                                        <label for="listed_1">Owner</label>
                                        <input name="listed" formControlName="listed_by" type="checkbox" id="listed_2" value="1" class="checkinput pgAvailable">
                                        <label for="listed_2">Broker</label>
                                        <input name="listed" formControlName="listed_by" type="checkbox" id="listed_3" value="4" class="checkinput pgAvailable">
                                        <label for="listed_3">Certified Agent</label>
                                    </div>
                                    <div class="tab-pane fade  rounded bg-white p-1 ft-h4" id="v-pills-settings2" role="tabpanel" aria-labelledby="v-pills-settings-tab">
                                        <input type="checkbox" id="fruit21" name="fruit-21" value="1" (click)="setValueOFPg('1')" [checked]="getPgValue.includes('1')" class="checkinput pgFor">
                                        <label for="fruit21"> Boys</label>
                                        <input type="checkbox" id="fruit22" name="fruit-22" value="2" (click)="setValueOFPg('2')" [checked]="getPgValue.includes('2')" class="checkinput pgFor">
                                        <label for="fruit22">Girls </label>
                                        <input type="checkbox" id="fruit23" name="fruit-23" value="3" (click)="setValueOFPg('3')" [checked]="getPgValue.includes('3')" class="checkinput pgFor">
                                        <label for="fruit23">For Both</label>
                                    </div>
                                    <div class="tab-pane fade  rounded bg-white p-1 ft-h4" id="v-pills-settings3" role="tabpanel" aria-labelledby="v-pills-settings-tab">
                                        <input type="checkbox" id="1bhk" class="checkinput noofBhk" [checked]="getBhkValue.includes('1')" value="1" (change)="setNoOfBhkValue($event)">
                                        <label for="1bhk">1 BHK</label>
                                        <input type="checkbox" id="2bhk" class="checkinput noofBhk" [checked]="getBhkValue.includes('2')" value="2" (change)="setNoOfBhkValue($event)">
                                        <label for="2bhk">2 BHK </label>
                                        <input type="checkbox" id="3bhk" class="checkinput noofBhk" [checked]="getBhkValue.includes('3')" value="3" (change)="setNoOfBhkValue($event)">
                                        <label for="3bhk">3 BHK</label>
                                        <input type="checkbox" id="4bhk" class="checkinput noofBhk" [checked]="getBhkValue.includes('4')" value="4" (change)="setNoOfBhkValue($event)">
                                        <label for="4bhk">4 BHK</label>
                                        <input type="checkbox" id="5bhk" class="checkinput noofBhk" [checked]="getBhkValue.includes('5')" value="5" (change)="setNoOfBhkValue($event)">
                                        <label for="5bhk">5 BHK & Above</label>
                                    </div>
                                </div>
                                <div class="row sort-filter">
                                    <div class="col-md-6 w-50">
                                        <button class="btn default btn primary flat results-btn" (click)="closeMobileFilter()" data-toggle="modal" type="button" data-target="#sortmodel">CLOSE</button>
                                    </div>
                                    <div class="col-md-6 w-50">
                                        <button class="btn default btn primary flat results-btn" (click)="closeMobileFilter()" style="font-weight: 600;color: #db0c0c;" id="sort-btn" type="submit">APPLY</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="row px-5">
            <!-- <div class="vastu-banner-imgb">
                            <img class="img-fluid" src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/331810/sample87.jpg" alt="">
                        </div> -->
            <a href="javascript: void(0);" class="filter-res-menu" (click)="openMobileFilter()"><i
                        class="ti-filter"></i></a>
            <div class="col-md-3 col-12 filter">
                <div class="col-md-12 col-12 dp0 main-filter main-filter-1">
                    <div class="col-md-12 col-12 dp0 dpad0">
                        <h5>Filter</h5>
                    </div>
                    <div class="ng-form-2">
                    <h6 style="font-size: 14px; font-weight: 700;">City <span class="required">*</span></h6>
                        <ng-autocomplete [initialValue]="initialValue" (inputCleared)="CityInputFocused()" (selected)="getSelectCity($event)" class="ng-quick" [data]="cityList" [searchKeyword]="keyword" placeHolder="Enter City" [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate">
                        </ng-autocomplete>
                        <span class="focus-input100"></span>
                        <span class="symbol-input100 symbl-2 position-absolute"><i style="margin-top: -440px;" id="like" class="fa fa-chevron-down" aria-hidden="true"></i></span>
                        <ng-template #itemTemplate let-item>
                            <div class="item">
                                <span [innerHTML]="item.name"></span>
                            </div>
                        </ng-template>
                        <ng-template #notFoundTemplate let-notFound>
                            <div [innerHTML]="notFound">City Not found.</div>
                        </ng-template>
                    </div>
                        <div class="col-md-12 col-12 dp0 filter1 filter-1">
                            <h6>Location </h6>
                            <div class="col-12 dpad0 bhkfor">
                                <input id="form-tags-4" ngx-google-places-autocomplete value="{{ searchForm.value.location }}" (keyup)="handleAddressChange($event,'mannual')" (onAddressChange)="handleAddressChange($event,'address')" [options]="options" placeholder='Type Location' class="filter-search-box input-box"
                                />
                            </div>
                        </div>
                    <form [formGroup]="searchForm" method="post" class="minm-for" accept-charset="utf-8">
                        <div class="col-md-12 col-12 dp0 filter1 filter-1">
                            <h6>Property Type </h6>
                            <div class="col-md-12 col-12 dpad0 bhkfor">
                                <ul class="list-inline">
                                    <li class="list-inline-item">
                                        <input type="radio" id="radio1" value="2" class="noof_bhk" name="property_type" formControlName="property_type" (click)="getPropertyTypeUrl('buy')">
                                        <label for="radio1">Buy</label>
                                    </li>
                                    <li class="list-inline-item">
                                        <input type="radio" id="radio2" value="1" class="noof_bhk" name="property_type" formControlName="property_type" (click)="getPropertyTypeUrl('rent')">
                                        <label for="radio2">Rent</label>
                                    </li>
                                    <li class="list-inline-item">
                                        <input type="radio" id="radio3" value="3" class="noof_bhk" name="property_type" formControlName="property_type" (click)="getPropertyTypeUrl('pg')">
                                        <label for="radio3">PG</label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <hr>
                        <span *ngIf="(searchForm.value.property_type=='1' || searchForm.value.property_type=='2')">
                                <div class="col-md-12 col-12 dp0 filter1 filter-1">
                                    <h6>Type of Property</h6>
                                    <div class="col-md-12 col-12 dpad0 bhkfor">
                                        <ul class="list-inline">
                                            <div class="card" (click)="div1Function1()">
                                                <p class="cust_p">Residential</p>
                                                <span class="checkmark"></span>
                </div>

                <div *ngIf="div1Function">
                    <li class="list-inline-item">
                        <input [checked]="getBhkValue.includes('1')"  value="1" (change)="setNoOfBhkValue($event)" type="checkbox" id="residenial34" class="noof_bhk bhk_checked">
                        <label for="residenial34">1 BHK</label>
                    </li>
                    <li class="list-inline-item">
                        <input [checked]="getBhkValue.includes('2')"  value="2" (change)="setNoOfBhkValue($event)" type="checkbox" id="residenial35" class="noof_bhk bhk_checked">
                        <label for="residenial35">2 BHK</label>
                    </li>
                    <li class="list-inline-item">
                        <input [checked]="getBhkValue.includes('3')"  value="3" (change)="setNoOfBhkValue($event)" type="checkbox" id="residenial36" class="noof_bhk bhk_checked">
                        <label for="residenial36">3 BHK</label>
                    </li>
                    <li class="list-inline-item">
                        <input [checked]="getBhkValue.includes('4')"  value="4" (change)="setNoOfBhkValue($event)" type="checkbox" id="residenial37" class="noof_bhk bhk_checked">
                        <label for="residenial37">3+ BHK</label>
                    </li>
                    <li class="list-inline-item">
                        <input [checked]="setProopertyTypeValuesArray.includes('8')" (change)="setPropertyTypeValues($event)" value="8" type="checkbox" id="residenial38" class="property_typesvalues bhk_checked">
                        <label for="residenial38">Villa</label>
                    </li>
                    <li class="list-inline-item">
                        <input type="checkbox" [checked]="setProopertyTypeArray.includes('1')" id="residenial1" class="property_type" value="1" (click)="setPropertyTypeValue()">
                        <label for="residenial1">Apartment/Flat/Builder Floor</label>
                    </li>
                    <li class="list-inline-item">
                        <input type="checkbox" [checked]="setProopertyTypeArray.includes('2')" id="residenial2" class="property_type" value="2" (click)="setPropertyTypeValue()">
                        <label for="residenial2">Independent House</label>
                    </li>
                    <li class="list-inline-item" *ngIf="searchForm.value.property_type=='2'">
                        <input type="checkbox" [checked]="setProopertyTypeArray.includes('4')" id="residenial33" class="property_type" value="4" (click)="setPropertyTypeValue()">
                        <label for="residenial33">Residential Plot/Land</label>
                    </li>
                </div>

                <div class="card" (click)="div2Function2()">
                    <p class="cust_p">Commercial</p>
                    <span class="checkmark"></span>
                </div>


                <div *ngIf="div2Function">
                    <li class="list-inline-item">
                        <input [checked]="setProopertyTypeValuesArray.includes('commercialplot')" (change)="setPropertyTypeValues($event)" value="commercialplot" type="checkbox" id="commercial4" class="property_typesvalues">
                        <label for="commercial4">Commercial Plots</label>
                    </li>
                    <li class="list-inline-item">
                        <input [checked]="setProopertyTypeValuesArray.includes('9')" (change)="setPropertyTypeValues($event)" value="9" type="checkbox" id="commercial5" class="property_typesvalues">
                        <label for="commercial5">Commercial Shops</label>
                    </li>
                    <li class="list-inline-item">
                        <input type="checkbox" [checked]="setProopertyTypeArray.includes('5')" id="commercial1" class="property_type" value="5" (click)="setPropertyTypeValue()">
                        <label for="commercial1">Commercial Showroom</label>
                    </li>
                    <li class="list-inline-item">
                        <input type="checkbox" [checked]="setProopertyTypeArray.includes('6')" id="commercial2" class="property_type" value="6" (click)="setPropertyTypeValue()">
                        <label for="commercial2">Commercial Office/Space</label>
                    </li>
                    <li class="list-inline-item">
                        <input type="checkbox" [checked]="setProopertyTypeArray.includes('commercialland')" id="commercial3" class="property_type" value="commercialland" (click)="setPropertyTypeValue()">
                        <label for="commercial3">Commercial Land</label>
                    </li>
                </div>

                <div class="card" (click)="div3Function3()">
                    <p class="cust_p">Agriculture</p>
                    <span class="checkmark"></span>
                </div>
                <div *ngIf="div3Function">
                    <li class="list-inline-item" *ngIf="searchForm.value.property_type=='2'">
                        <input type="checkbox" [checked]="setProopertyTypeArray.includes('8')" id="agriculture1" class="property_type" value="8" (click)="setPropertyTypeValue()">
                        <label for="agriculture1">Agriculture Land</label>
                    </li>
                    <li class="list-inline-item">
                        <input type="checkbox" [checked]="setProopertyTypeArray.includes('9')" id="agriculture2" class="property_type" value="9" (click)="setPropertyTypeValue()">
                        <label for="agriculture2">Farmhouse</label>
                    </li>
                </div>
                <div class="card" (click)="div4Function4()">
                    <p class="cust_p">Industrial</p>
                    <span class="checkmark"></span>
                </div>
                <div *ngIf="div4Function">
                    <li class="list-inline-item">
                        <input type="checkbox" [checked]="setProopertyTypeArray.includes('10')" id="agriculture3" class="property_type" value="10" (click)="setPropertyTypeValue()">
                        <label for="agriculture3">Industry Plot</label>
                    </li>
                    <li class="list-inline-item">
                        <input type="checkbox" [checked]="setProopertyTypeArray.includes('13')" id="industry1" class="property_type" value="13" (click)="setPropertyTypeValue()">
                        <label for="industry1">Factory</label>
                    </li>
                </div>
                </ul>
            </div>
        </div>
        <hr>
        </span>
        <div class="col-12 dp0 filter1 filter-1" *ngIf="(searchForm.value.property_type=='1' || searchForm.value.property_type=='2')">
            <h6>Sale Type</h6>
            <div class="col-md-12 col-12 dpad0 bhkfor">
                <ul class="list-inline">
                    <li class="list-inline-item">
                        <input  type="checkbox" id="saleType1" class="saleType" value="2" (click)="setValueOfSaleType()">
                        <label for="saleType1">New Property</label>
                    </li>
                    <li class="list-inline-item">
                        <input  type="checkbox" id="saleType2" class="saleType" value="1" (click)="setValueOfSaleType()">
                        <label for="saleType2">Resale</label>
                    </li>
                </ul>
            </div>
        </div>
        <hr *ngIf="(searchForm.value.property_type=='1' || searchForm.value.property_type=='2')">
        <div class="col-12 dp0 filter1 filter-1" *ngIf="(searchForm.value.property_type=='1' || searchForm.value.property_type=='2')">
            <h6>Listed By</h6>
            <div class="col-md-12 col-12 dpad0 bhkfor">
                <ul class="list-inline">
                    <li class="list-inline-item">
                        <input type="checkbox" (click)="setValueOfListedBy()" id="you_are1" class="noof_bhk listedBy" value="2">
                        <label for="you_are1">Owner</label>
                    </li>
                    <li class="list-inline-item">
                        <input type="checkbox" (click)="setValueOfListedBy()" id="you_are2" class="noof_bhk listedBy" value="1">
                        <label for="you_are2">Broker</label>
                    </li>
                    <li class="list-inline-item">
                        <input type="checkbox" (click)="setValueOfListedBy()" id="you_are3" class="noof_bhk listedBy" value="4">
                        <label for="you_are3">Certified Agent</label>
                    </li>
                </ul>
            </div>
        </div>
        <hr *ngIf="(searchForm.value.property_type=='1' || searchForm.value.property_type=='2')">
        <div class="col-12 dp0 filter1 filter-1" *ngIf="(searchForm.value.property_type=='1' || searchForm.value.property_type=='2')">
            <h6>Possession Type</h6>
            <div class="col-md-12 col-12 dpad0 bhkfor">
                <ul class="list-inline">
                    <li class="list-inline-item">
                        <input type="checkbox" id="Possession1" class="noof_bhk possessionType" value="1" (click)="setValueOfPossessionType()">
                        <label for="Possession1">Ready to Move</label>
                    </li>
                    <li class="list-inline-item">
                        <input type="checkbox" id="Possession2" class="noof_bhk possessionType" value="2" (click)="setValueOfPossessionType()">
                        <label for="Possession2">Under Construction</label>
                    </li>
                </ul>
            </div>
        </div>
        <hr *ngIf="(searchForm.value.property_type=='1' || searchForm.value.property_type=='2')">
        <div class="col-12 dp0 filter1 filter-1">
            <h6>Budget</h6>
            <div class="col-md-12 col-12 dpad0 bhkfor">
                <ul class="list-inline">
                    <li class="list-inline-item">
                        <select class="cs-select cs-skin-elastic" formControlName="min_budget">
                                                <option value="">Min</option>
                                                <option *ngFor="let minPrice of budgetMin" value="{{ minPrice }}">
                                                    {{ getBudgetWords(minPrice) }}</option>
                                            </select>
                    </li>
                    <li class="list-inline-item"> - </li>
                    <li class="list-inline-item">
                        <select formControlName="max_budget">
                                                <option value="">Max</option>
                                                <option *ngFor="let maxPrice of getBudgetMaxValue()" value="{{ maxPrice }}">
                                                    {{ getBudgetWords(maxPrice) }}</option>
                                            </select>
                    </li>
                </ul>
            </div>
        </div>
        <hr>

        <span *ngIf="searchForm.value.property_type=='3'">
                                <div class="col-md-12 col-12 dp0 filter1">
                                    <h6>Available category</h6>
                                    <div class="col-12 dpad0 bhkfor">
                                        <ul class="list-inline">
                                            <li class="list-inline-item">
                                                <input type="checkbox" id="pg_professional" class="noof_bhk pg_available"
                                                    value="1" (click)="setValueOfPgAvl()"
                                                    [checked]="getPgAvlValue.includes('1')">
                                                <label for="pg_professional">For Professionals</label>
                                            </li>
                                            <li class="list-inline-item">
                                                <input type="checkbox" id="pg_students" class="noof_bhk pg_available"
                                                    value="2" (click)="setValueOfPgAvl()"
                                                    [checked]="getPgAvlValue.includes('2')">
                                                <label for="pg_students">For Students</label>
                                            </li>
                                            <li class="list-inline-item">
                                                <input type="checkbox" id="pg_professstudents" class="noof_bhk pg_available"
                                                    value="3" (click)="setValueOfPgAvl()"
                                                    [checked]="getPgAvlValue.includes('3')">
                                                <label for="pg_professstudents">For Professionals & Students</label>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <hr>
                            </span>
        <span *ngIf="searchForm.value.property_type=='3'">
                                <div class="col-md-12 col-12 dp0 filter1">
                                    <h6>Available for</h6>
                                    <div class="col-12 dpad0 bhkfor">
                                        <ul class="list-inline">
                                            <li class="list-inline-item">
                                                <input name="pg" type="radio" id="pg_boys" class="noof_bhk pg_for" value="1"
                                                    (click)="setValueOFPg('1')" [checked]="getPgValue.includes('1')">
                                                <label for="pg_boys">Boys</label>
                                            </li>
                                            <li class="list-inline-item">
                                                <input name="pg" type="radio" id="pg_girls" class="noof_bhk pg_for" value="2"
                                                    (click)="setValueOFPg('2')" [checked]="getPgValue.includes('2')">
                                                <label for="pg_girls">Girls</label>
                                            </li>
                                            <li class="list-inline-item">
                                                <input name="pg" type="radio" id="pg_unisex" class="noof_bhk pg_for" value="3"
                                                    (click)="setValueOFPg('3')" [checked]="getPgValue.includes('3')">
                                                <label for="pg_unisex">Both</label>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <hr>
                            </span>
        <!-- <span *ngIf="setProopertyTypeArray.includes('1') &&  !setProopertyTypeArray.includes('2') &&  !setProopertyTypeArray.includes('4') ">
                                <span *ngIf="searchForm.value.property_type=='1' ||  searchForm.value.property_type=='2'">
                                    <div class="col-md-12 col-12 dp0 filter1">
                                        <h6>No. of BHK </h6>
                                        <div class="col-12 dpad0 bhkfor">
                                            <ul class="list-inline">
                                                <li class="list-inline-item">
                                                    <input type="checkbox" id="checkbox1" class="noof_bhk bhk_checked"
                                                        value="1" (click)="setNoOfBhkValue()">
                                                    <label for="checkbox1">1 BHK</label>
                                                </li>
                                                <li class="list-inline-item">
                                                    <input type="checkbox" id="checkbox2" class="noof_bhk bhk_checked"
                                                        value="2" (click)="setNoOfBhkValue()">
                                                    <label for="checkbox2">2 BHK</label>
                                                </li>
                                                <li class="list-inline-item">
                                                    <input type="checkbox" id="checkbox3" class="noof_bhk bhk_checked"
                                                        value="3" (click)="setNoOfBhkValue()">
                                                    <label for="checkbox3">3 BHK</label>
                                                </li>
                                                <li class="list-inline-item">
                                                    <input type="checkbox" id="checkbox4" class="noof_bhk bhk_checked"
                                                        value="4" (click)="setNoOfBhkValue()">
                                                    <label for="checkbox4">4 BHK</label>
                                                </li>
                                                <li class="list-inline-item">
                                                    <input type="checkbox" id="checkbox5" class="noof_bhk bhk_checked"
                                                        value="5" (click)="setNoOfBhkValue()">
                                                    <label for="checkbox5">5 BHK & Above</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <hr>
                                </span>
        </span> -->

        <div class="col-12 dp0 filter1 filter-1">
            <h6>Sort By </h6>
            <div class="col-md-12 col-12 dpad0 bhkfor">
                <ul class="list-inline">
                    <li class="list-inline-item">
                        <input type="radio" id="relevance" class="noof_bhk" formControlName="sort_by" value="1">
                        <label for="relevance">Relevance</label>
                    </li>
                    <li class="list-inline-item">
                        <input type="radio" id="l2h" class="noof_bhk" formControlName="sort_by" value="2">
                        <label for="l2h">Low to High</label>
                    </li>
                    <li class="list-inline-item">
                        <input type="radio" id="h2l" class="noof_bhk" formControlName="sort_by" value="3">
                        <label for="h2l">High to Low</label>
                    </li>
                    <li class="list-inline-item">
                        <input type="radio" id="o2n" class="noof_bhk" formControlName="sort_by" value="4">
                        <label for="o2n">Old to New</label>
                    </li>
                    <li class="list-inline-item">
                        <input type="radio" id="n2o" class="noof_bhk" formControlName="sort_by" value="5">
                        <label for="n2o">New to Old</label>
                    </li>
                </ul>
            </div>
        </div>

        <div class="col-md-12 col-12 text-center mobile-ok-filterbtn">
            <button class="btn btn-danger" type="button" (click)="resetMobileFilter()"> <i
                                        class="ti-reload"></i>
                                    Reset</button> &nbsp;
            <!-- <button class="btn btn-danger" (click)="closeMobileFilter()"> <i class="ti-search"></i>
                                        Search</button> -->
        </div>

        </form>
    </div>
</div>
<!-- new filter  code -->
<div class="col-md-7 col-12 pd-0" *ngIf="totalProperty>0">
    <div class="col-md-12 col-12 search-result-box p-0">
        <h6>{{ totalProperty }} Properties found</h6>
    </div>
    <div class="col-md-12 col-12 search-result-box p-0" style="text-transform: capitalize;" *ngIf="getSearchText">
        <!-- <h6>{{ getSearchText }}</h6> -->
    </div>

    <div class="row marginZero">
        <div class="col-md-12 col-12 main-listing p-0" infinite-scroll [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle" (scrolled)="getAllPropertyWithScroll()">
            <div class="row propria-prop-content" *ngFor="let property of properties;let i=index ">

                <div class="col-lg-4 col-12 pd-l0 mp0 pr-0 pr-lg-2">
                    <div class="row">
                        <div class="col-md-12">
                            <a href="{{ property.property_slug }}">
                                <figure>
                                    <div id="demo123{{i}}" class="carousel slide" data-ride="carousel" data-interval="false">
                                        <div class="carousel-inner">
                                            <div class="carousel-item" *ngFor="let image of property.images;let first=first;" [ngClass]="{active: first}">
                                                <img lazyLoad="{{ image.img_path }}" defaultImage="assets/images/propira-default.webp" class="img-fluid w-100" alt="listing image">

                                            </div>
                                        </div>
                                        <a class="carousel-control-prev" href="#demo123{{i}}" data-slide="prev" *ngIf="property.images.length>1">
                                            <i class="ti-angle-left"></i>
                                        </a>
                                        <a class="carousel-control-next" href="#demo123{{i}}" data-slide="next" *ngIf="property.images.length>1">
                                            <i class="ti-angle-right"></i>
                                        </a>
                                    </div>
                                    <div class="image-overlay"></div>
                                    <span class="media-file">
                                                        <i class="ti-video-camera" *ngIf="property.video"></i>
                                                        <i class="ti-camera"></i> {{ property.images.length}}
                                                    </span>
                                </figure>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-12 py-2 px-0">
                        <div class="propertyType">
                            <div class="row align-items-center">
                                <div class="col col-sm-6 col-md-6 col-lg-12">
                                    <div class="d-flex align-items-center postBy justify-content-left justify-content-lg-center">
                                        <p style="font-size: 12px; font-weight: 700;" class="m-0 mr-1">Posted By: </p>
                                        <h2 *ngIf="property.source_type=='1'">Bro<span>ker</span></h2>
                                        <h2 *ngIf="property.source_type=='2' || property.source_type=='3'">Ow<span>ner</span></h2>
                                        <h2 *ngIf="property.source_type=='4'">Certified <span>Agent</span></h2>
                                    </div>
                                </div>
                                <div class="col col-sm-6 col-md-6 col-lg-12 mt-0 mt-lg-1 py-2 py-sm-0 propria-body propirabody-new">
                                    <div class="justify-content-end justify-content-lg-center by-build buy-build-new  mp015 p-0">
                                        <a target="_blank" href="{{ property.property_slug }}">
                                            <div class="property-agent">
                                                <ul>
                                                    <li style="display: none;"><a href="#">{{ property.user_name
                                                                            }}</a></li>
                                                    <li style="font-size: 12px; font-weight: 700;"><i class="fa fa-calendar" style="font-size: 14px;"></i> Posted on {{ property.posted_date }}</li>
                                                </ul>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="col-lg-8 col-12 pd-0">

                    <div class="propria-body">

                        <div class="row">
                            <div class="col-md-12">
                                <div class="row marginZero">
                                    <div class="col-md-12 col-12 pd-0">
                                        <a target="_blank" href="{{ property.property_slug }}">
                                            <h6 class="names-propria1">
                                                <b style="font-size:15px">{{ property.title_first }}</b>{{ property.title_second }}
                                            </h6>
                                        </a>
                                    </div>
                                </div>
                                <div class="propria-body main-price">
                                    <div class="row">
                                        <div class="col-md-9 col-7">
                                            <a target="_blank" href="{{ property.property_slug }}">
                                                <p *ngIf="(property.property_type=='2')" style="font-size:14px">
                                                    <b>₹{{ property.priceinshort_words }}</b>&nbsp;&nbsp;
                                                    <small *ngIf="(property.property_type=='1' || property.property_type=='2')">₹{{
                                                                    property.priceper_unitvalue }}</small>
                                                </p>

                                                <p style="font-size:14px" *ngIf="(property.property_type=='1' || property.property_type=='3')">
                                                    <b>₹{{ property.priceper_unitvalue }}</b>
                                                </p>
                                            </a>
                                        </div>
                                        <div class="col-md-3 col-5">
                                            <span class="whatsnear"><a href="javascript: void(0);"
                                                                (click)="whatsNearByModalMap(property.location_lat,property.location_long,property.location)"><i
                                                                    class="ti-location-pin"></i> What's near by</a></span>
                                        </div>
                                    </div>
                                </div>


                                <!---rent category listing-->
                                <div class="propria-body" *ngIf="property.property_type=='1' && property.looking_subcat_type=='1' ">
                                    <a target="_blank" href="{{ property.property_slug }}">
                                        <ul class="flats-price">
                                            <li class="room">
                                                <span>Room</span>{{ property.room }}
                                            </li>
                                            <li class="available">
                                                <span>Rental allowed for</span> {{ property.rental_allowfor }}
                                            </li>
                                            <li class="flooring">
                                                <span>Property on which floor</span>
                                                <!-- {{
                                                                property.property_which_floors }} -->
                                                <span *ngIf="property.property_which_floors=='-1'" style="color: black; font-weight: 900; font-size: 12px;">Basement</span>
                                                <span *ngIf="property.property_which_floors=='0'" style="color: black; font-weight: 900; font-size: 12px;">Ground</span>
                                                <span *ngIf=" property.property_which_floors>'0'" style="color: black; font-weight: 900; font-size: 12px;">{{
                                                                property.property_which_floors }}</span>
                                            </li>
                                            <li class=" furnishing">
                                                <span>Furnishing</span>{{ property.furnished_type}}
                                            </li>

                                        </ul>
                                    </a>
                                </div>

                                <div class="propria-body" *ngIf="property.property_type=='1' && property.looking_subcat_type=='2' ">
                                    <a target="_blank" href="{{ property.property_slug }}">
                                        <ul class="flats-price">
                                            <li class="room">
                                                <span>Room</span>{{ property.room }}
                                            </li>
                                            <li class="available">
                                                <span>Rental allowed for</span> {{ property.rental_allowfor }}
                                            </li>

                                            <li class="rent-part">
                                                <span *ngIf="property.whichpart_torent=='1'">Which part to
                                                                rent</span>
                                                <span *ngIf="property.whichpart_torent=='2'">Floor to
                                                                rent</span>
                                                <span *ngIf="property.whichpart_torent=='1'" style="color: black; font-weight: 900; font-size: 12px;">Complete
                                                                Property</span>
                                                <span *ngIf="property.floor_torent=='-1' && property.whichpart_torent=='2'" style="color: black; font-weight: 900; font-size: 12px;">Basement</span>
                                                <span class="spec-item-value" *ngIf="property.floor_torent=='0' &&  property.whichpart_torent=='2'" style="color: black; font-weight: 900; font-size: 12px;">Ground</span>
                                                <span class="spec-item-value" *ngIf="property.floor_torent>'0' && property.whichpart_torent=='2'" style="color: black; font-weight: 900; font-size: 12px;">{{
                                                                property.floor_torent }}</span>

                                            </li>
                                            <li class="furnishing">
                                                <span>Furnishing</span>{{ property.furnished_type}}
                                            </li>
                                        </ul>
                                    </a>
                                </div>

                                <div class="propria-body" *ngIf="property.property_type=='1' && property.looking_subcat_type=='5' ">
                                    <a target="_blank" href="{{ property.property_slug }}">
                                        <ul class="flats-price">
                                            <li class="property-area">
                                                <span>Area</span> {{ property.area }}
                                            </li>
                                            <li class="facing">
                                                <span>Facing</span>{{ property.facing }}
                                            </li>
                                            <li class="facing-road">
                                                <span>Width of Facing Road</span>{{ property.facing_road }} Foot
                                            </li>
                                            <li class="furnishing">
                                                <span>Furnishing</span>{{ property.furnished_type}}
                                            </li>
                                        </ul>
                                    </a>
                                </div>

                                <div class="propria-body" *ngIf="property.property_type=='1' && property.looking_subcat_type=='6' ">
                                    <a target="_blank" href="{{ property.property_slug }}">
                                        <ul class="flats-price">
                                            <li class="property-area">
                                                <span>Area</span> {{ property.area }}
                                            </li>
                                            <li class="facing">
                                                <span>Facing</span>{{ property.facing }}
                                            </li>
                                            <li class="facing-road">
                                                <span>Width of Facing Road</span>{{ property.facing_road }} Foot
                                            </li>

                                            <li class="furnishing">
                                                <span>Furnishing</span>{{ property.furnished_type}}
                                            </li>
                                        </ul>
                                    </a>
                                </div>

                                <div class="propria-body" *ngIf="property.property_type=='1' && property.looking_subcat_type=='7' ">
                                    <a target="_blank" href="{{ property.property_slug }}">
                                        <ul class="flats-price">
                                            <li class="property-area">
                                                <span>Area</span> {{ property.area }}
                                            </li>
                                            <li class="facing-road">
                                                <span>Width of Facing Road</span>{{ property.facing_road }} Foot
                                            </li>

                                            <li class="facing">
                                                <span>Facing</span>{{ property.facing }}
                                            </li>

                                            <li class="power-backup">
                                                <span>Electricity Connection</span>{{ property.electrical_conn }}
                                            </li>
                                        </ul>
                                    </a>
                                </div>

                                <div class="propria-body" *ngIf="property.property_type=='1' && property.looking_subcat_type=='9' ">
                                    <a target="_blank" href="{{ property.property_slug }}">
                                        <ul class="flats-price">
                                            <li class="property-area">
                                                <span>Land Area</span> {{ property.area }}
                                            </li>
                                            <li class="property-area">
                                                <span>Constructed Area</span>{{ property.constructed_area}}
                                            </li>
                                            <li class="room" *ngIf="(property.property_type=='1' && (property.looking_subcat_type=='1' || property.looking_subcat_type=='2' || property.looking_subcat_type=='9' || property.looking_subcat_type=='13')) || (property.property_type=='2' && (property.looking_subcat_type=='1' || property.looking_subcat_type=='2'))">
                                                <span>Room</span>{{ property.room }}
                                            </li>

                                            <li class="furnishing">
                                                <span>Furnishing</span>{{ property.furnished_type}}
                                            </li>
                                        </ul>
                                    </a>
                                </div>

                                <div class="propria-body" *ngIf="property.property_type=='1' && property.looking_subcat_type=='10' ">
                                    <a target="_blank" href="{{ property.property_slug }}">
                                        <ul class="flats-price">
                                            <li class="property-area">
                                                <span>Land Area</span> {{ property.area }}
                                            </li>
                                            <li class="facing-road">
                                                <span>Width of Facing Road</span>{{ property.facing_road }} Foot
                                            </li>
                                            <li class="water-supply">
                                                <span>Water Supply</span>{{ property.watersupply_conn}}
                                            </li>
                                            <li class="power-backup">
                                                <span>Electricity Connection</span>{{ property.electrical_conn }}
                                            </li>
                                        </ul>
                                    </a>
                                </div>

                                <div class="propria-body" *ngIf="property.property_type=='1' && property.looking_subcat_type=='13' ">
                                    <a target="_blank" href="{{ property.property_slug }}">
                                        <ul class="flats-price">
                                            <li class="property-area" *ngIf="(property.looking_subcat_type=='4' || (property.property_type=='1' && (property.looking_subcat_type=='5' || property.looking_subcat_type=='6')) || property.looking_subcat_type=='7' || property.looking_subcat_type=='8' || property.looking_subcat_type=='9' || property.looking_subcat_type=='10' || property.looking_subcat_type=='13')">
                                                <span>Land Area</span> {{ property.area }}
                                            </li>
                                            <li class="facing-road">
                                                <span>Width of facing road</span>{{ property.facing_road }} Foot
                                            </li>
                                            <li class="room">
                                                <span>Room</span>{{ property.room }}
                                            </li>
                                            <li class="status">
                                                <span>Possession Status </span>{{ property.possession_status }}
                                            </li>
                                        </ul>
                                    </a>
                                </div>
                                <!---sell category listing-->
                                <div class="propria-body" *ngIf="property.property_type=='2' && property.looking_subcat_type=='1' ">
                                    <a target="_blank" href="{{ property.property_slug }}">
                                        <ul class="flats-price">
                                            <li class="super-area">
                                                <span>Super Area</span>{{ property.super_area }}
                                            </li>
                                            <li class="status">
                                                <span>Possession Status </span>{{ property.possession_status }}
                                            </li>
                                            <li class="transaction-type">
                                                <span>Transaction Type </span>{{ property.transaction_status }}
                                            </li>
                                            <li class="furnishing">
                                                <span>Furnishing</span>{{ property.furnished_type}}
                                            </li>
                                        </ul>
                                    </a>
                                </div>

                                <div class="propria-body" *ngIf="property.property_type=='2' && property.looking_subcat_type=='2' ">
                                    <a target="_blank" href="{{ property.property_slug }}">
                                        <ul class="flats-price">
                                            <li class="property-area">
                                                <span>Area</span> {{ property.area }}
                                            </li>
                                            <li class="room">
                                                <span>Room</span>{{ property.room }}
                                            </li>

                                            <li class="status" *ngIf="(property.property_type=='2' && (property.looking_subcat_type=='1' || property.looking_subcat_type=='2' || property.looking_subcat_type=='5' || property.looking_subcat_type=='6' || property.looking_subcat_type=='9' || property.looking_subcat_type=='13')) || (property.property_type=='1' && property.looking_subcat_type=='13')">
                                                <span>Possession Status </span>{{ property.possession_status }}
                                            </li>
                                            <li class="furnishing">
                                                <span>Furnishing</span>{{ property.furnished_type}}
                                            </li>

                                        </ul>
                                    </a>
                                </div>

                                <div class="propria-body" *ngIf="property.property_type=='2' && property.looking_subcat_type=='4' ">
                                    <a target="_blank" href="{{ property.property_slug }}">
                                        <ul class="flats-price">
                                            <li class="property-area">
                                                <span>Area</span> {{ property.area }}
                                            </li>
                                            <li class="facing-road">
                                                <span>Width of Facing Road</span>{{ property.facing_road }} Foot
                                            </li>

                                            <li class="facing">
                                                <span>Facing</span>{{ property.facing }}
                                            </li>

                                            <li class="ownership">
                                                <span>Ownership</span>{{ property.ownership}}
                                            </li>
                                        </ul>
                                    </a>
                                </div>

                                <div class="propria-body" *ngIf="property.property_type=='2' && property.looking_subcat_type=='5' ">
                                    <a target="_blank" href="{{ property.property_slug }}">
                                        <ul class="flats-price">
                                            <li class="super-area">
                                                <span>Super Area</span>{{ property.super_area }}
                                            </li>
                                            <li class="flooring" *ngIf="property.want_tosell=='1'">
                                                <span>Property on which floor</span>
                                                <span *ngIf="property.property_which_floors=='-1'" style="color: black; font-weight: 900; font-size: 12px;">Basement</span>
                                                <span class="spec-item-value" *ngIf="property.property_which_floors=='0'" style="color: black; font-weight: 900; font-size: 12px;">Ground</span>
                                                <span class="spec-item-value" *ngIf="property.property_which_floors>'0'" style="color: black; font-weight: 900; font-size: 12px;">{{
                                                                property.property_which_floors }}</span>
                                            </li>
                                            <li class="flooring" *ngIf="property.want_tosell=='2'">
                                                <span>Total Floor</span>{{ property.noof_floors=='0' ? 'Ground' : property.noof_floors }}
                                            </li>
                                            <li class="status">
                                                <span>Possession Status </span>{{ property.possession_status }}
                                            </li>
                                            <li class="furnishing">
                                                <span>Furnishing</span>{{ property.furnished_type}}
                                            </li>
                                        </ul>
                                    </a>
                                </div>

                                <div class="propria-body" *ngIf="property.property_type=='2' && property.looking_subcat_type=='6' ">
                                    <a target="_blank" href="{{ property.property_slug }}">
                                        <ul class="flats-price">
                                            <li class="super-area">
                                                <span>Super Area</span>{{ property.super_area }}
                                            </li>
                                            <li class="flooring" *ngIf="property.want_tosell=='1'">
                                                <span>Property on which floor</span>
                                                <span *ngIf="property.property_which_floors=='-1'" style="color: black; font-weight: 900; font-size: 12px;">Basement</span>
                                                <span class="spec-item-value" *ngIf="property.property_which_floors=='0'" style="color: black; font-weight: 900; font-size: 12px;">Ground</span>
                                                <span class="spec-item-value" *ngIf="property.property_which_floors>'0'" style="color: black; font-weight: 900; font-size: 12px;">{{
                                                                property.property_which_floors }}</span>
                                            </li>
                                            <li class="flooring" *ngIf="property.want_tosell=='2'">
                                                <span>Total Floor</span>{{ property.noof_floors=='0' ? 'Ground' : property.noof_floors }}
                                            </li>
                                            <li class="status">
                                                <span>Possession Status </span>{{ property.possession_status }}
                                            </li>
                                            <li class="furnishing">
                                                <span>Furnishing</span>{{ property.furnished_type}}
                                            </li>
                                        </ul>
                                    </a>
                                </div>

                                <div class="propria-body" *ngIf="property.property_type=='2' && property.looking_subcat_type=='7' ">
                                    <a target="_blank" href="{{ property.property_slug }}">
                                        <ul class="flats-price">
                                            <li class="property-area">
                                                <span>Area</span> {{ property.area }}
                                            </li>
                                            <li class="facing-road">
                                                <span>Width of Facing Road</span>{{ property.facing_road }} Foot
                                            </li>
                                            <li class="facing">
                                                <span>Facing</span>{{ property.facing }}
                                            </li>
                                            <li class="ownership">
                                                <span>Ownership</span>{{ property.ownership}}
                                            </li>
                                        </ul>
                                    </a>
                                </div>

                                <div class="propria-body" *ngIf="property.property_type=='2' && property.looking_subcat_type=='8' ">
                                    <a target="_blank" href="{{ property.property_slug }}">
                                        <ul class="flats-price">
                                            <li class="property-area">
                                                <span>Land Area</span> {{ property.area }}
                                            </li>
                                            <li class="facing-road">
                                                <span>Width of Facing Road</span>{{ property.facing_road }} Foot
                                            </li>
                                            <li class="water-supply">
                                                <span>Water Supply</span>{{ property.watersupply_conn}}
                                            </li>

                                            <li class="power-backup">
                                                <span>Electricity Connection</span>{{ property.electrical_conn }}
                                            </li>
                                        </ul>
                                    </a>
                                </div>

                                <div class="propria-body" *ngIf="property.property_type=='2' && property.looking_subcat_type=='9' ">
                                    <a target="_blank" href="{{ property.property_slug }}">
                                        <ul class="flats-price">
                                            <li class="property-area">
                                                <span>Land Area</span> {{ property.area }}
                                            </li>
                                            <li class="status">
                                                <span>Possession Status </span>{{ property.possession_status }}
                                            </li>
                                            <li class="furnishing">
                                                <span>Furnishing</span>{{ property.furnished_type}}
                                            </li>
                                            <li class="property-area">
                                                <span>Constructed Area</span>{{ property.constructed_area}}
                                            </li>
                                        </ul>
                                    </a>
                                </div>

                                <div class="propria-body" *ngIf="property.property_type=='2' && property.looking_subcat_type=='10' ">
                                    <a target="_blank" href="{{ property.property_slug }}">
                                        <ul class="flats-price">
                                            <li class="property-area">
                                                <span>Land Area</span> {{ property.area }}
                                            </li>
                                            <li class="facing-road">
                                                <span>Width of Facing Road</span>{{ property.facing_road }} Foot
                                            </li>
                                            <li class="water-supply">
                                                <span>Water Supply</span>{{ property.watersupply_conn}}
                                            </li>
                                            <li class="power-backup">
                                                <span>Electricity Connection</span>{{ property.electrical_conn }}
                                            </li>
                                        </ul>
                                    </a>
                                </div>

                                <div class="propria-body" *ngIf="property.property_type=='2' && property.looking_subcat_type=='13' ">
                                    <a target="_blank" href="{{ property.property_slug }}">
                                        <ul class="flats-price">
                                            <li class="property-area">
                                                <span>Land Area</span> {{ property.area }}
                                            </li>
                                            <li class="facing-road">
                                                <span>Width of Facing Road</span>{{ property.facing_road }} Foot
                                            </li>
                                            <li class="status">
                                                <span>Possession Status </span>{{ property.possession_status }}
                                            </li>
                                            <li class="ownership">
                                                <span>Ownership</span>{{ property.ownership}}
                                            </li>
                                        </ul>
                                    </a>
                                </div>


                                <!----pg listing-->

                                <div class="propria-body" *ngIf="property.property_type=='3'">
                                    <a target="_blank" href="{{ property.property_slug }}">
                                        <ul class="flats-price">
                                            <li class="available" *ngIf="property.property_type=='3'">
                                                <span>Available for</span>{{ property.gender }}
                                            </li>
                                            <li class="room-type" *ngIf="property.property_type=='3'">
                                                <span>Room</span>{{ property.room_type }}
                                            </li>
                                            <li class="food" *ngIf="property.property_type=='3'">
                                                <span>Food</span>{{ property.food_option }}
                                            </li>
                                            <li class="pgcategory" *ngIf="property.property_type=='3'">
                                                <span>Available Category</span>{{ property.available_category }}
                                            </li>
                                        </ul>
                                    </a>
                                </div>

                            </div>
                            <div class="col-md-12 py-2">
                                <div class="row align-items-center">
                                    <div class="col-md-6 col-sm-6 col-auto py-2 py-sm-0 pr-0">
                                        <ul class="post-share m-0">
                                            <li class="fs-14">Share On</li>
                                            <li class="wtsp"><a href="javascript: void(0);" (click)="sharePost('google',property.property_slug)"><i
                                                                    class="fa  fa-google"></i></a></li>
                                            <li class="fb-icon"><a href="javascript: void(0);" (click)="sharePost('facebook',property.property_slug)"><i
                                                                    class="ti-facebook"></i></a></li>
                                            <li class="instagram-icon"><a href="javascript: void(0);" (click)="sharePost('instagram',property.property_slug)"><i
                                                                    class="ti-instagram"></i></a></li>
                                            <li class="wtsp"><a href="javascript: void(0);" (click)="sharePost('whatsup',property.property_slug)"><i
                                                                    class="fa fa-whatsapp"></i></a></li>
                                        </ul>
                                    </div>
                                    <div class="col-md-6 col-sm-6 col py-2 py-sm-0 propria-body propirabody-new" style="padding-left: 5px;">
                                        <div class="by-build buy-build-new mp015 p-0 justify-content-sm-end justify-content-end">
                                            <div class="d-flex">
                                                <div class="listing_actions" *ngIf="!property.propertyof_user">
                                                    <a href="javascript: void(0);" title="Shortlist" (click)="addToWishlist(property.property_id,$event,property.looking_type,property.property_type,property.propertyid_no)">
                                                        <img style="height: 32px;" alt="wishlist-icon" src="assets/images/wishlist-icon.png" class="img-fluid" [ngClass]="{'shortlisted':chkPropertyWishlist.includes(property.property_id) }">
                                                    </a>
                                                </div>
                                                <div class="final-buttons" *ngIf="!property.propertyof_user">
                                                    <a *ngIf="(property.property_type=='1' || property.property_type=='2')" href="javascript: void(0);" (click)="openLeadForm(property.property_type,property.property_id,property.looking_type,property.propertyid_no, property);leadForm.openLeadForm()"><i
                                                                        class="ti-mobile"></i>
                                                                    Contact Now</a>

                                                    <a *ngIf="(property.property_type=='3')" href="javascript: void(0);" (click)="openLeadForm('3',property.property_id,property.looking_type,property.propertyid_no,property);leadForm.openLeadForm()"><i
                                                                        class="ti-mobile"></i>
                                                                    Contact Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <!-- sinner -->
    <div class="row">
        <div class="col-md-12 col-12 p-4 mp0">
            <ngx-spinner bdOpacity=0.9 bdColor="" size="default" color="#db0c0c" type="ball-pulse-sync" [fullScreen]="false">
            </ngx-spinner>
        </div>
    </div>
</div>

<div class="col-md-7 col-12 pd 0" *ngIf="properties.length==0">
    <div class="col-md-12 col-12 no-result-found usersformms">
        <img alt="transparent" src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="assets/images/property-not-found.png" class="img-fluid" style="height:200px">
        <p>No results matching your search!<br>
            <small>Try removing some of the filters to get matching propertyresults</small>
        </p>
        <a href="javascript:void(0)" class="common-button" (click)="resetFilters()">Reset filters</a>
    </div>
</div>

<div class="col-md-2 col-12 pd-0 ad-sidebar" *ngIf="advBanner">
    <div class="col-md-12 col-12 listing-ad mp0">
        <div class="card mb-2 col-md-12 col-12  ">
            <a target="_blank" href="{{advBanner.url1}}"><img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="{{advBanner.image1}}" class="img-fluid" alt="ad image"></a>
        </div>
        <div class="card mb-2 col-md-12 col-6">
            <a target="_blank" href="{{advBanner.url2}}"><img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="{{advBanner.image2}}" class="img-fluid" alt="ad image"></a>
        </div>
    </div>
</div>
</div>
<div *ngIf="breadCrumbType=='buy_agriculture'">
    <div class="row listing-content">
        <div class="col-md-12">
            <h4>Are you searching for Farming Land for sale? </h4>
            <p>
                For the Indian economy, agriculture is the backbone.There are many agricultural lands available for sale in Alwar. You can easily buy farming land at various locations according to your budget. And we will help you purchase the perfect one.
            </p>
            <p>
                We have a complete list of agricultural lands and farm houses available in Alwar for sale. If you are looking for farming properties online, you came to the right place. Every piece of information about the property and recent photos of that land are
                available on our website. Simply click on the property you like, and you will get every detail you need.

            </p>
            <p>
                From searching the right property to helping you at every step of your purchase, you name it, and we do it. You don't have to go anywhere else for any sort of help or guidance concerning your purchase. Since we provide free assistance and end-to-end support,
                you can just contact us and leave all the tension.
            </p>
            <h4>Why Choose Propira to Buy Agricultural Land for sale?</h4>
            <p>
                Propira does not only provide you a list of the best available agricultural land for sale in Alwar, but it also guides you along the way. Whether it is negotiating for a fair price, checking the credibility of the seller and the property, safe payment
                transaction, or doing all the paperwork. We never miss any detail.
            </p>
            <p>
                Our 15 years of experience in the real estate business taught us everything about it. So, if you want to buy agricultural land, you have us. We will find you a deal at your conditions. Doesn't matter if you want to buy farming land near the main road
                or a particular village land for sale. We have got you all covered.
            </p>
            <p>
                We ensure 100% credibility. You can trust us with your dream of buying an evergreen farming land.
            </p>
        </div>
    </div>
    <div class="col-md-12 list-faq">
        <div class="property-specification property-description" id="faqs">
            <div class="row marginZero">
                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                    <h5>FAQs</h5>
                </div>
                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                    <div id="accordion">
                        <div class="card">
                            <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapse1">
                                    <h3> Is farming land affordable in Alwar?</h3>
                                </a>
                            </div>
                            <div id="collapse1" class="collapse show" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>Yes, you can buy farming land in Alwar as per your budget. You can search for properties under your budget at our website.

                                    </h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse2">
                                    <h3> How do you negotiate an Agricultural property purchase?</h3>
                                </a>
                            </div>
                            <div id="collapse2" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>Negotiation of an agricultural property depends on the location and area of the property.
                                    </h4>
                                </div>
                            </div>
                        </div>


                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse4">
                                    <h3> Is propira a good platform for Buying a Village Land in Alwar?</h3>
                                </a>
                            </div>
                            <div id="collapse4" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>Proper is one of the best platforms for any real estate transaction, whether it is village land, residential, commercial, or industrial property.
                                    </h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse5">
                                    <h3> Is buying agricultural land better than residential?</h3>
                                </a>
                            </div>
                            <div id="collapse5" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>For a long-term investment, agricultural land and residential property both are good options. Though, farming land offers higher total returns and involves lower levels of risk.
                                    </h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse3">
                                    <h3> Where should I sell my agricultural land?</h3>
                                </a>
                            </div>
                            <div id="collapse3" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>You can post your property at Propira, and we will find genuine buyers who will be willing to give you a fair price.</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="breadCrumbType=='buy_residential'">
    <div class="row listing-content">
        <div class="col-md-12">
            <h4>Are you Searching for Residential Properties for sale? </h4>
            <p>
                If you want to buy residential properties in Alwar, then you have come to the right address. Here you can effortlessly find many residential plots, apartments, flats, and independent houses available for purchase. For each property listed here, every
                piece of information is available like carpet area, super area, number of rooms, flooring, facing, furnishing, nearby areas, etc. You can also look at the numerous photos of the property. And if you like what you see, request a site visit
                to take a tour of the property and look for yourself whether it fits your needs or not.
            </p>
            <p>
                With an easy search, you will discover the best residential properties for sale on our website. If you have any specific location or budget in mind, simply apply some filters and you will get a list of properties according to your requirements. And for
                any doubt, Propira hai na!
            </p>
            <p>
                Let's start searching for your new home together.
            </p>
            <h4>Why choose Propira to Buy Residential Properties in Alwar?
            </h4>
            <p>
                Searching for the perfect home, getting a fair price, and doing all the paperwork by yourself sounds overwhelming. But don't worry, we are here for your help.
            </p>
            <p>
                Propira is your one-stop solution for any problem related to purchasing your new home. From finding the right property to making it yours, we provide our best service at every single step. Getting you an affordable price, setting all the necessary paperwork,
                and payment transactions without any trouble are some of the services we provide. </p>
            <p>
                Our 15 years of experience in real estate make us one of the best property dealers in Alwar. With our free assistance and end-to-end support, you can easily buy residential plot in Alwar. And for any question or even a small doubt, you can contact us
                without any worry. </p>
            <p>
                So, leave all the tension of buying residential property on us and get yourself ready to shift to your new home.

            </p>
        </div>
    </div>
    <div class="col-md-12 list-faq">
        <div class="property-specification property-description" id="faqs">
            <div class="row marginZero">
                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                    <h5>FAQs</h5>
                </div>
                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                    <div id="accordion">
                        <div class="card">
                            <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapse1">
                                    <h3> Which are some top places to buy Residential Properties in Alwar?
                                    </h3>
                                </a>
                            </div>
                            <div id="collapse1" class="collapse show" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>There are several excellent locations in Alwar where you can buy residential properties like Telco Chowk, 200 feet road, etc.
                                    </h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse2">
                                    <h3> Are there any ready to move properties available in Alwar? </h3>
                                </a>
                            </div>
                            <div id="collapse2" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>In Alwar, you can easily find many ready to move in properties whether you are looking for apartments, flats, or independent houses.
                                    </h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse3">
                                    <h3> Is there any availability of affordable apartments in Alwar to buy?
                                    </h3>
                                </a>
                            </div>
                            <div id="collapse3" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>Countless apartments at affordable prices are available to buy in Alwar at various locations.</h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse4">
                                    <h3> Can I buy a Residential Plot in the Porsche area in Alwar? </h3>

                                </a>
                            </div>
                            <div id="collapse4" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>Yes, you can easily buy residential plots in the Porsche area in Alwar. Select your desired location while applying filters.
                                    </h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse5">
                                    <h3> Are 1/2/3 Bhk Flats for sale available at Propira? </h3>

                                </a>
                            </div>
                            <div id="collapse5" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>Lots of 1/2/3 Bhk Flats are available on our website. Now filter your searches according to your wants.
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div *ngIf="breadCrumbType=='rent'">
    <div class="row listing-content">
        <div class="col-md-12">
            <h4>Properties on Rent </h4>
            <p>
                Searching for the ideal rental property doesn't sound easy. But we make that easy for you. We provide you with the ease of searching rental properties online with information about every little detail of the property. Not only that, but you will also
                get free assistance from our real estate advisors.
            </p>
            <p>
                This applies to all types of rental properties, whether you want residential properties, industrial properties, agricultural plot lands, or commercial properties on rent. You will find the best residential properties for rent in Alwar without any trouble.
                Just select your requirements, apply appropriate filters, and you will see all the suitable properties. Once you find the ones you are interested in, contact us for a site visit and further steps to finalize the deal. We will help you
                with every step and ensure that the deal is done at a fair price and with decent terms and conditions. For any doubt or question, you can contact us without any worry. We are in the real estate business for 15 years. You don't have to
                take any stress over taking a property on rent. You can trust us with your dream.
            </p>

            <h4>Why Choose Propira for Properties on Rent ?
            </h4>
            <p>
                Propira is best among the best real estate advisor in the city. Forget about the tension of taking a property on rent because we will make it easy for you. You will get the best service without any doubt.
            </p>
            <p>
                We are a team of independent real estate advisors combined to make real estate easy for everyone. We bring owners and tenants all under one roof as we believe in nothing but transparency. We guide you, support you, and help you. With the experience of
                15 years, our community is growing stronger and getting bigger day by day.
            </p>
            <p>
                Whether it's about taking a residential, commercial, or industrial property for rent, we can help you with every property type. Even if you want to get high-demand agricultural land for rent, you have come to the right place. We will help you not only
                find the right property but also in finalizing the deal. All the credit checks and paperwork will be done under our supervision, leaving no scope for any mistakes or misunderstandings. We will be right there with you all the time, so you
                don't have to worry at all. Renting is easy, you will say.
            </p>
        </div>
    </div>
    <div class="col-md-12 list-faq">
        <div class="property-specification property-description" id="faqs">
            <div class="row marginZero">
                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                    <h5>FAQs</h5>
                </div>
                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                    <div id="accordion">
                        <div class="card">
                            <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapse1">
                                    <h3> Do I need to Pay two months in advance for rental commercial properties? </h3>
                                </a>
                            </div>
                            <div id="collapse1" class="collapse show" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>There is no hard and fast rule for paying two month's rent in advance for renting commercial properties. It depends on the deal you have with the owner.
                                    </h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse2">
                                    <h3> What is the process of Residential Properties for Rent in Alwar?
                                    </h3>
                                </a>
                            </div>
                            <div id="collapse2" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>Search the available residential properties for rent on our website. Pick the ones you like and contact us with the same. We will take you on a tour of the property, help to finalize the deal, and doing the paperwork.</h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse3">
                                    <h3> What are the best nearby areas for Rental farming land in Alwar?
                                    </h3>
                                </a>
                            </div>
                            <div id="collapse3" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>Tijara road, chikani, MIA are some of the nearby areas where you can easily find affordable farming land for rent.</h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse4">
                                    <h3> Is there any Affordable Industrial Property on rent listed on propira? </h3>

                                </a>
                            </div>
                            <div id="collapse4" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>Yes, we have many affordable industrial properties listed on our website for rent. You can choose them according to your requirements.
                                    </h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse5">
                                    <h3> Are rental properties listed by verified owners/brokers on propira?
                                    </h3>
                                </a>
                            </div>
                            <div id="collapse5" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>One thing you can be sure of on our website is credibility assurance. We first verify every property listed on our website.
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div *ngIf="breadCrumbType=='buy'">
    <div class="row listing-content">
        <div class="col-md-12">
            <h4>Buy Properties on Sale </h4>
            <p>
                Gone the era when purchasing your ideal property at a fair price was just a matter of luck. Today, propira, one of the best real estate advisors in the city, is there to help you at every step of your purchase.
            </p>
            <p>
                Whether you want to buy residential properties, commercial properties, or industrial properties in Alwar, we help you find the perfect match. And not just discovering it, we assist with negotiating the deal, legal documentation, and every small or big
                task needed for finalizing the deal. Even if you want to buy agricultural land, you can trust us. We are at our best in dealing with every kind of property.
            </p>
            <p>
                You will find every single detail of the property and recent photos too. You can easily book a site visit to see it yourself. We give 100% credibility assurance. And also offer free assistance.
            </p>
            <p>
                Have a fixed budget? No problem, on our website, you will come across some of the best properties in Alwar at affordable prices.
            </p>
            <p>
                Have a preferred location in mind? Just let us know your choices, and we will be right back with the most suitable fit for you.
            </p>
            <p>
                Apply the appropriate filters for the best results.
            </p>

            <h4>Why Choose Propira for Properties ?
            </h4>
            <p>
                Propira is a well-known name in the real estate business. We developed this trust and made our name with our 15 years of experience. Offering quality service, establishing a genuine relationship between buyer and seller, and landing our customers a great
                deal are some of our best qualities.
            </p>
            <p>
                We offer complimentary assistance throughout your buying journey. We are efficient at every task related to the purchase. Whether it is, preparing the paperwork, negotiating the deal, or a safe payment transaction. You don't have to worry at all, and
                our experts will make sure that the deal will be done without any hindrance.
            </p>
            <p>
                We provide you with a single platform to buy commercial properties, residential properties, agricultural plot land, and industrial properties. You can effortlessly find the best properties available in Alwar and all the details about them. With our guidance,
                you can easily buy industrial property in the comfort of your home. We provide you with end-to-end support. For any query, you can directly contact us. Since for every real estate transaction, propira hai na!
            </p>
        </div>
    </div>
    <div class="col-md-12 list-faq">
        <div class="property-specification property-description" id="faqs">
            <div class="row marginZero">
                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                    <h5>FAQs</h5>
                </div>
                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                    <div id="accordion">
                        <div class="card">
                            <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapse1">
                                    <h3> What is the whole process of buying Agricultural Land? </h3>
                                </a>
                            </div>
                            <div id="collapse1" class="collapse show" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>After selecting the agricultural land listed on our website, contact our team for further steps. We will contact the seller, and after you both agree to the terms and conditions, finalize the deal. We will guide you
                                        throughout the way.
                                    </h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse2">
                                    <h3> How to check for seller details for buying a commercial space?
                                    </h3>
                                </a>
                            </div>
                            <div id="collapse2" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>You can see the ownership details in the specification section of the property. For more information, you can click on CONTACT NOW to contact our team. And we will answer all of your questions related to the seller
                                        and the property.</h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse3">
                                    <h3> Are Residential Properties affordable in Alwar? </h3>
                                </a>
                            </div>
                            <div id="collapse3" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>Yes, you can easily find many residential properties like flats, plot lands, and independent houses at affordable prices in Alwar.</h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse4">
                                    <h3> What are some top localities of Alwar to buy industrial property?
                                    </h3>

                                </a>
                            </div>
                            <div id="collapse4" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>MIA, Tijara road and the old industrial area are some of the top locations in Alwar for buying industrial property.
                                    </h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse5">
                                    <h3> Is propira Reliable for buying properties? </h3>
                                </a>
                            </div>
                            <div id="collapse5" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>Yes, propira is an entirely reliable platform for purchasing properties in Alwar. We ensure 100% credibility.
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="breadCrumbType=='buy_commercial'">
    <div class="row listing-content">
        <div class="col-md-12">
            <h4>Are you looking for the Best Commercial Properties for Sale? </h4>
            <p>
                With a rapid increase in opportunities, Alwar is becoming a perfect place to expand your family business or to start a new one. Whether you are searching for a small shop on busy market streets or a classy showroom in a mall, you can find all types of
                commercial properties for sale in Alwar right here.
            </p>
            <p>
                If you are looking for a new commercial shop, office space, or showroom, you just have to apply few filters. Let us know your requirements, and we'll let you know about the best available commercial space for sale in your budget. Even if you want to buy
                commercial land in Alwar, you have come to the right place. Start it from scratch and build it as you like.
            </p>
            <p>
                You will find every piece of information about the property on our website and photos too. Though, if you want to look for yourself, request a site visit. And not to mention that we will help you at every step of your purchase, from negotiating to paperwork.
            </p>
            <p>
                Without any worry, let's shop for your shop.
            </p>
            <h4>Why Choose Propira to Buy Commercial Land in Alwar?</h4>
            <p>
                A perfect shop is necessary for your business growth. But It’s hard to know which one is right for you.
            </p>
            <p>
                With 15 years of experience in the real estate business, we are the perfect fit in providing you with the right guidance. If you want to buy commercial properties in Alwar, look no further. We will give you free assistance, credibility assurance, and
                end-to-end support. Besides, help from an expert in real estate will save you a lot of time and keep you away from any trouble.
            </p>
            <p>
                From finding the perfect commercial property to signing all the papers, we will always be at your side. You can trust us with any issue at any step of your purchase. With us, buy commercial shops with ease. We believe in a fair deal, and we will make
                sure you get one.
            </p>
        </div>
    </div>
    <div class="col-md-12 list-faq">
        <div class="property-specification property-description" id="faqs">
            <div class="row marginZero">
                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                    <h5>FAQs</h5>
                </div>
                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                    <div id="accordion">
                        <div class="card">
                            <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapse1">
                                    <h3> Can I find the best commercial properties on propira in Alwar?</h3>
                                </a>
                            </div>
                            <div id="collapse1" class="collapse show" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>On our website, we only list the best commercial properties in Alwar.
                                    </h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse2">
                                    <h3> What questions should you ask when buying commercial property?</h3>
                                </a>
                            </div>
                            <div id="collapse2" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>You should ask for details about the ownership, carpet area, super area, construction age, electricity, parking, and all the property-related documents.</h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse3">
                                    <h3> How do you negotiate a commercial property purchase?</h3>
                                </a>
                            </div>
                            <div id="collapse3" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>Negotiate based on the location and area of the property.</h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse4">
                                    <h3> Which are some top places to buy Commercial Space in Alwar?</h3>
                                </a>
                            </div>
                            <div id="collapse4" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>Places near Bhagat Singh Circle, hope circus, and city malls are best to buy commercial properties.</h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse5">
                                    <h3> Are Furnished Commercial Offices available in Alwar?</h3>

                                </a>
                            </div>
                            <div id="collapse5" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>There are many furnished commercial offices available on Propira at top locations.
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="breadCrumbType=='buy_industrial'">
    <div class="row listing-content">
        <div class="col-md-12">
            <h4>Best Industrial Land for Sale </h4>
            <p>
                Alwar is developing at a very fast rate, and one of the main reasons for its development is the increase in the number of industries. Today, many companies of different sectors are becoming a part of this development.
            </p>
            <p>
                If you want to set up a factory and you are looking for industrial property for sale in Alwar, you have come to the right place. On Propira, you will find details about the best industrial properties that are up for sale. Every piece of information is
                available on our website. With just a click, you can even book a site visit. Our experienced real estate advisor will contact you and guide you at every stage of your purchase in every possible manner. From finding the perfect location
                to signing the papers, we are always there for you.
            </p>
            <p>
                We will make your property purchase experience hassle-free. Just let us know your requirements. And you can easily find your ideal industrial property in Alwar with our help.
            </p>
            <p>
                Let's start searching for your ideal property match.
            </p>
            <h4>Why Choose Propira to Buy Industrial Land for Sale?</h4>
            <p>
                If you want to buy industrial land for sale in Alwar, Propira is the best deal you can ever get. We offer you the best service for your real estate transactions. You will get free assistance throughout your buying journey with 100% credibility assurance.
                Not only that, but we also provide end-to-end support for the times when you have any doubts.
            </p>
            <p>
                We are in the real estate business for 15 years. Learning from the experience, we will guide you the best way we can. From trouble-free payment transactions to all the legal documentation, we help you with every step of your purchase. So that you can
                leave all the tensions of the purchase, and focus only on setting up the factory.
            </p>
            <p>
                Want to get the deal at the best price? Propira Hai Na!
            </p>
            <p>
                Worried about the paperwork? Propira Hai Na!
            </p>
            <p>
                Stressed about frauds? Propira Hai Na!
            </p>
            <p>
                For everything, Propira Hai Na!
            </p>
        </div>
    </div>
    <div class="col-md-12 list-faq">
        <div class="property-specification property-description" id="faqs">
            <div class="row marginZero">
                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                    <h5>FAQs</h5>
                </div>
                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                    <div id="accordion">
                        <div class="card">
                            <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapse1">
                                    <h3> What are some areas in Alwar to Buy Industrial Land? </h3>
                                </a>
                            </div>
                            <div id="collapse1" class="collapse show" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>In Alwar, industrial lands are mainly available at old industrial areas (near kali mori railway crossing) and Matsya Industrial Area.
                                    </h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse2">
                                    <h3> Can I purchase Industrial Property on Loan in Alwar? </h3>
                                </a>
                            </div>
                            <div id="collapse2" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>Yes, you can easily take a loan to purchase an industrial property. You can use it to buy factory land and a shed.</h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse3">
                                    <h3> Is propira reliable for buying an industrial Portion? </h3>
                                </a>
                            </div>
                            <div id="collapse3" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>Propira is a reliable and genuine platform for all your real estate transactions. Having experience of 15 years, it offers the best services for your industrial property purchase.</h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse4">
                                    <h3> How to proceed if I want to buy an industrial property in Alwar?
                                    </h3>
                                </a>
                            </div>
                            <div id="collapse4" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>Start with searching industrial properties on our website while applying any applicable filters like budget and location. For any further guidance, you can contact us at support@propira.com.</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div *ngIf="breadCrumbType=='rent_industrial'">
    <div class="row listing-content">
        <div class="col-md-12">
            <h4>Best Residential Properties for Rent </h4>
            <p>
                If you are looking for residential properties for rent in Alwar, you have come to the right address. On propira, you will find the best rental properties. You can effortlessly explore them without leaving your desk. With our help, you can easily get an
                apartment on rent that fits into your budget. And also, at your desired location.
            </p>
            <p>
                Whether you are searching for an apartment, independent house, or flat, every type of property is available on our website. You can get every piece of information about the property. From essential features to special mentions, not only you can read each
                detail, but can also look at the recent photos. And if it fits your requirements, request a site visit to see it yourself and become sure before making any decision.
            </p>
            <p>
                Finalizing the apartment is your job, and the rest you can leave on us. You don't have to worry about negotiating the deal, the complexity of legal documents, or any other problem relating to your lease or rental agreement.
            </p>
            <p>
                Let's start searching for a new home for you.
            </p>
            <h4>Why Choose Propira for Rental Properties in Alwar?</h4>
            <p>
                We always choose an expert to take advice for our problems. Just like that, you should prefer propira for renting properties. Our 15 years of experience in the real estate business makes us an expert in this field. We offer free assistance and end-to-end
                support for your hassle-free renting experience.
            </p>
            <p>
                Propira is the one-stop answer for all your questions related to real estate transactions. We guide you at every step of your journey since getting a flat on rent is not easy for someone who has zero knowledge of real estate. We will make sure you will
                get your ideal house on rent. You can leave all your tension as we will get you an absolute deal at a fair price.
            </p>
        </div>
    </div>
    <div class="col-md-12 list-faq">
        <div class="property-specification property-description" id="faqs">
            <div class="row marginZero">
                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0 mb-2">
                    <h5>FAQs</h5>
                </div>
                <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12 p-0">
                    <div id="accordion">
                        <div class="card">
                            <div class="card-header">
                                <a class="card-link" data-toggle="collapse" href="#collapse1">
                                    <h3> Are there rental properties available from owners?</h3>
                                </a>
                            </div>
                            <div id="collapse1" class="collapse show" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>Yes, various rental properties that are available from owners are listed on our website.
                                    </h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse2">
                                    <h3> What are the top areas in Alwar to rent a property?</h3>
                                </a>
                            </div>
                            <div id="collapse2" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>Residential properties near telco circle, Tijara road are among the top areas to rent a property in Alwar.</h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse3">
                                    <h3> Are there any Affordable Rental Apartments available in Alwar?</h3>
                                </a>
                            </div>
                            <div id="collapse3" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>There are many affordable properties available for rent according to the area and location of the apartment.</h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse4">
                                    <h3> Is there availability of furnished residential property in Alwar on rent?
                                    </h3>
                                </a>
                            </div>
                            <div id="collapse4" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>Yes, you can easily find a fully furnished residential property for rent. Modular kitchen and wardrobe are some of the most common features available.</h4>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#collapse5">
                                    <h3> Best platform for independent rental properties in Alwar?</h3>
                                </a>
                            </div>
                            <div id="collapse5" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <h4>Propira is the best platform to search for independent rental properties in Alwar. On our website, you will find the best properties available for rent.</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- </div> -->
</div>

<!---Lead Form-->
<app-leadform [property_id]="leadpropetyId" #leadForm [leadTableName]="leadTableName" [leadTablePropertyType]="leadTablePropertyType" [leadTableLookingType]="leadTableLookingType" [leadpropertyIdno]="leadpropertyIdno" [leadPropertyPrice]="leadPropertyPrice" [leadPropertyTitle]="leadPropertyTitle"></app-leadform>

<div class="modal fade" id="mapModal">
    <div class="modal-dialog">
        <div class="modal-content" style="padding: 10px;background:#606062">
            <button type="button" class="close" data-dismiss="modal">
                    <i class="ti-close"></i>
                </button>
            <div class="row marginZero">
                <div class="col-md-4 col-4 pd-0 nearby-items">
                    <div id="accordion">
                        <div class="card">
                            <div class="card-header">
                                <a class="card-link nearestgoogleplace" data-toggle="collapse" href="#collapseOne" (click)="nearByPlaceList('nearby','nearby')">
                                    <i class="ti-target"></i> Nearest
                                    <span class="symbol-input100 loading-icon nearby" style="display:none">
                                            <div class="lds-dual-ring"></div>
                                        </span>
                                </a>
                            </div>
                            <div id="collapseOne" class="collapse show" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList"><i class="ti-location-pin"></i> {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">Result not found with in 0.5 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#busStop" (click)="nearByPlaceList('bus_station','bus_station')">
                                    <i class="ti-direction"></i> Bus Stop
                                    <span class="symbol-input100 loading-icon bus_station" style="display:none">
                                            <div class="lds-dual-ring"></div>
                                        </span>
                                </a>
                            </div>
                            <div id="busStop" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList"><i class="ti-location-pin"></i> {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No Bus Stop found with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#school" (click)="nearByPlaceList('school','school')">
                                    <i class="ti-pencil-alt"></i> School
                                    <span class="symbol-input100 loading-icon school" style="display:none">
                                            <div class="lds-dual-ring"></div>
                                        </span>
                                </a>
                            </div>
                            <div id="school" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList| slice:0:5; let ind=index;"><i class="ti-location-pin"></i> {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No School found with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#shoppingMall" (click)="nearByPlaceList('shopping_mall','shopping_mall')">
                                    <i class="ti-shopping-cart"></i> Shopping Mall
                                    <span class="symbol-input100 loading-icon shopping_mall" style="display:none">
                                            <div class="lds-dual-ring"></div>
                                        </span>
                                </a>
                            </div>
                            <div id="shoppingMall" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList| slice:0:5; let ind=index;"><i class="ti-location-pin"></i> {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No Shopping Mall found with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#hospitals" (click)="nearByPlaceList('hospital','hospital')">
                                    <i class="ti-support"></i> Hospitals
                                    <span class="symbol-input100 loading-icon hospital" style="display:none">
                                            <div class="lds-dual-ring"></div>
                                        </span>
                                </a>
                            </div>
                            <div id="hospitals" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList| slice:0:5; let ind=index;"><i class="ti-location-pin"></i> {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No Hospitals found with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#bankAtms" (click)="nearByPlaceList('bank,atm','bank')">
                                    <i class="ti-credit-card"></i> Banks/ATMs
                                    <span class="symbol-input100 loading-icon bank" style="display: none">
                                            <div class="lds-dual-ring"></div>
                                        </span>
                                </a>
                            </div>
                            <div id="bankAtms" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList| slice:0:5; let ind=index;"><i class="ti-location-pin"></i> {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No Bank/ATM's with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#groceryStores" (click)="nearByPlaceList('grocery_or_supermarket','grocery')">
                                    <i class="ti-briefcase"></i> Grocery Stores
                                    <span class="symbol-input100 loading-icon grocery" style="display:none">
                                            <div class="lds-dual-ring"></div>
                                        </span>
                                </a>
                            </div>
                            <div id="groceryStores" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList| slice:0:5; let ind=index;"><i class="ti-location-pin"></i> {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No Grocery Stores found with in 1 Km
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#pharmacy" (click)="nearByPlaceList('pharmacy','pharmacy')">
                                    <i class="ti-clipboard"></i> Pharmacy
                                    <span class="symbol-input100 loading-icon pharmacy" style="display:none">
                                            <div class="lds-dual-ring"></div>
                                        </span>
                                </a>
                            </div>
                            <div id="pharmacy" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList| slice:0:5; let ind=index;"><i class="ti-location-pin"></i> {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No Pharmacy found with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#restaurent" (click)="nearByPlaceList('restaurent','restaurent')">
                                    <i class="ti-home"></i> Restaurant
                                    <span class="symbol-input100 loading-icon restaurent" style="display:none">
                                            <div class="lds-dual-ring"></div>
                                        </span>
                                </a>
                            </div>
                            <div id="restaurent" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList| slice:0:5; let ind=index;"><i class="ti-location-pin"></i> {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No Restaurant found with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#movies" (click)="nearByPlaceList('movie_theater','movie_theater')">
                                    <i class="ti-video-clapper"></i> Movies
                                    <span class="symbol-input100 loading-icon movie_theater" style="display:none">
                                            <div class="lds-dual-ring"></div>
                                        </span>
                                </a>
                            </div>
                            <div id="movies" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList| slice:0:5; let ind=index;"><i class="ti-location-pin"></i> {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No Movies found with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#park" (click)="nearByPlaceList('park','park')">
                                    <i class="ti-shine"></i> Park
                                    <span class="symbol-input100 loading-icon park" style="display:none">
                                            <div class="lds-dual-ring"></div>
                                        </span>
                                </a>
                            </div>
                            <div id="park" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList| slice:0:5; let ind=index;"><i class="ti-location-pin"></i> {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No Park found with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#gym" (click)="nearByPlaceList('gym','gym')">
                                    <i class="ti-wheelchair"></i> Gym
                                    <span class="symbol-input100 loading-icon gym" style="display:none">
                                            <div class="lds-dual-ring"></div>
                                        </span>
                                </a>
                            </div>
                            <div id="gym" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList| slice:0:5; let ind=index;"><i class="ti-location-pin"></i> {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No Gym found with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#petrolPump" (click)="nearByPlaceList('petrol_station','petrol')">
                                    <i class="ti-paint-bucket"></i> Petrol Pump
                                    <span class="symbol-input100 loading-icon petrol" style="display:none">
                                            <div class="lds-dual-ring"></div>
                                        </span>
                                </a>
                            </div>
                            <div id="petrolPump" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList| slice:0:5; let ind=index;"><i class="ti-location-pin"></i> {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No Petrol Pump found with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-12 pd-0" id="gmap_canvas">
                    <agm-map [latitude]="location_lat" [zoomControl]="false" [longitude]="location_long" [mapTypeControl]='true' [mapDraggable]="true" [zoom]=" 13" [minZoom]="3" [maxZoom]="17" (mapReady)="setmap($event)">
                        <agm-marker [latitude]="location_lat" [longitude]="location_long" iconUrl="https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|4286f4">
                            <agm-info-window>
                                <strong [innerHtml]="location"></strong>
                            </agm-info-window>
                        </agm-marker>

                        <agm-marker *ngFor="let m of nearplaceList | slice:0:5" [latitude]="m.geometry.location.lat()" [longitude]="m.geometry.location.lng()">
                            <agm-info-window>
                                <strong [innerHtml]="m.name"></strong>
                            </agm-info-window>
                        </agm-marker>
                    </agm-map>
                </div>
            </div>
            <button type="button" class="close" data-dismiss="modal"><i class="ti-close"></i></button>
        </div>
    </div>
</div>
</div>